import { setTerms } from './helpers';

export const setSpecialtyTypesTerms = setTerms('specialty_types');
